<template>
  <div id="app">
      <router-view/>
  </div>
</template>

<script>
import positionBanner  from './components/positionBanner/positionBanner'
export default {
  name: 'App',
  components:{positionBanner},
  data(){
    return{
    }
  },
  mounted(){

  }
}
</script>

<style>
  @font-face{
    font-family:myFont;
    src:url('../static/font/Digital-7Mono.ttf');
  }
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue